<template>
  <div id="app" class="wrap">
    <!-- include="MyMessage"-->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive">
        <!-- 这里是会被缓存的视图组件，比如 page1,page2 -->
      </router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive">
      <!-- 这里是不被缓存的视图组件，比如 page3 -->
    </router-view>
    <!-- <keep-alive>
       <router-view></router-view>
     </keep-alive>-->
    <div id="alert" v-if="MSIE">
      <img :src="globalUrl + '/static/dist/img/alert.png'" alt="">
    </div>
  </div>
</template>

<script>


  export default {

    name: 'app',
    data() {
      return {
        globalUrl: '..', // API.GlobalUrl
        MSIE: false
      }
    },
    methods: {
      //操作按钮事件
    },
    mounted: function(){
      var that = this;
      var browser = navigator.appName;
      var b_version = navigator.appVersion;
      var version = b_version.split(";");
      var trim_Version = version[1].replace(/[ ]/g, "");
      if(browser == "Microsoft Internet Explorer"){
        if (trim_Version == "MSIE6.0" || trim_Version == "MSIE7.0" || trim_Version == "MSIE8.0") {
          that.MSIE = true;
        }
      }
    }
  }
</script>

<style>
  #alert {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #ccc;
    z-index: 9999;
  }

  #alert img {
    margin-top: 45%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue